<form [formGroup]="filterForm" (ngSubmit)="onSearch()" *ngIf="filterForm">
    <div class="row">
        <div
            *ngFor="let field of fields"
            [class]="field.type === 'dateperiod' ? 'col-12' : 'col-sm-6 col-lg-4 col-xl-3'">
            <ng-container [ngSwitch]="field.type">

                <ng-container *ngSwitchCase="'text'">
                    <mat-form-field appearance="outline" class="w-100" *ngIf="isSimpleField(field)">
                        <mat-label class="text-overflow-ellipsis">{{ field.displayName }}</mat-label>
                        <input matInput
                            [formControlName]="field.name"
                            [type]="'text'">
                        <button type="button" matSuffix mat-icon-button aria-label="Clear" (click)="clearControl(field.name)" *ngIf="filterForm.get(field.name)?.value">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                </ng-container>

                <ng-container *ngSwitchCase="'rut'">
                    <mat-form-field appearance="outline" class="w-100" *ngIf="isSimpleField(field)">
                        <mat-label class="text-overflow-ellipsis">{{ field.displayName }}</mat-label>
                        <input
                            matInput
                            [formControlName]="field.name"
                            [type]="'text'">
                        <button type="button" matSuffix mat-icon-button aria-label="Clear" (click)="clearControl(field.name)" *ngIf="filterForm.get(field.name)?.value">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                </ng-container>

                <ng-container *ngSwitchCase="'email'">
                    <mat-form-field appearance="outline" class="w-100" *ngIf="isSimpleField(field)">
                        <mat-label class="text-overflow-ellipsis">{{ field.displayName }}</mat-label>
                        <input
                            matInput
                            [formControlName]="field.name"
                            [type]="'email'">
                        <button type="button" matSuffix mat-icon-button aria-label="Clear" (click)="clearControl(field.name)" *ngIf="filterForm.get(field.name)?.value">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                </ng-container>

                <ng-container *ngSwitchCase="'number'">
                    <mat-form-field appearance="outline" class="w-100" *ngIf="isSimpleField(field)">
                        <mat-label class="text-overflow-ellipsis">{{ field.displayName }}</mat-label>
                        <input
                            matInput
                            [formControlName]="field.name"
                            [type]="'number'">
                        <button type="button" matSuffix mat-icon-button aria-label="Clear" (click)="clearControl(field.name)" *ngIf="filterForm.get(field.name)?.value">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                </ng-container>

                <ng-container *ngSwitchCase="'date'">
                    <mat-form-field appearance="outline" class="w-100" *ngIf="isSimpleField(field)">
                        <mat-label class="text-overflow-ellipsis">{{ field.displayName }}</mat-label>
                        <input
                            matInput
                            [formControlName]="field.name"
                            [matDatepicker]="picker"
                            placeholder="DD-MM-YYYY"
                            maxlength="10"
                            class="mat-datepicker-input">
                        <mat-error *ngIf="filterForm.get(field.name)?.hasError('matDatepickerParse')">
                            Ingresa una fecha válida (ej: 31-12-2025)
                        </mat-error>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker-toggle matSuffix (click)="clearControl(field.name)" *ngIf="filterForm.get(field.name)?.value">
                            <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </ng-container>

                <ng-container *ngSwitchCase="'select'">
                    <mat-form-field appearance="outline" class="w-100" *ngIf="isSelectField(field) && field.options.length <= 4">
                        <mat-label class="text-overflow-ellipsis">{{ field.displayName }}</mat-label>
                        <mat-select [formControlName]="field.name">
                            <mat-option>-- Seleccionar --</mat-option>
                            <mat-option *ngFor="let option of field.options" [value]="option.value">
                                {{ option.displayName }}
                            </mat-option>
                        </mat-select>
                        <button type="button" matSuffix mat-icon-button aria-label="Clear" (click)="clearControl(field.name)" *ngIf="filterForm.get(field.name)?.value">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                </ng-container>

                <ng-container *ngSwitchCase="'select'">
                    <mat-form-field appearance="outline" class="w-100" *ngIf="isSelectField(field) && field.options.length >= 5">
                        <mat-label>{{ field.displayName }}</mat-label>
                        <input matInput type="text" [formControlName]="field.name" [matAutocomplete]="auto">
                        <mat-autocomplete #auto="matAutocomplete" panelWidth="fit-content">
                            <mat-option *ngFor="let option of filteredOptionsMap[field.name] | async" [value]="option.value">
                                {{ option.displayName }}
                            </mat-option>
                        </mat-autocomplete>
                        <button type="button" matSuffix mat-icon-button aria-label="Clear" (click)="clearControl(field.name)" *ngIf="filterForm.get(field.name)?.value">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                </ng-container>

                <ng-container *ngSwitchCase="'autocomplete'">
                    <mat-form-field appearance="outline" class="w-100" *ngIf="isAutocompleteField(field)">
                        <mat-label>{{ field.displayName }}</mat-label>
                        <input matInput type="text" [formControlName]="field.name" [matAutocomplete]="auto">
                        <mat-autocomplete #auto="matAutocomplete" panelWidth="fit-content" class="autocomplete-panel">
                            <mat-option *ngIf="autocompleteLoadingMap[field.name]" disabled>
                                <mat-spinner diameter="20" />
                            </mat-option>

                            <ng-container *ngIf="!autocompleteLoadingMap[field.name]">
                                <mat-option *ngIf="filterForm.get([field.name])?.value?.length < 3" disabled>
                                    Ingrese al menos 3 caracteres para buscar
                                </mat-option>

                                <mat-option *ngIf="autocompleteOptionsMap[field.name]?.length === 0 && filterForm.get([field.name])?.value?.length >= 3" disabled>
                                    No se encontraron resultados
                                </mat-option>

                                <mat-option *ngFor="let option of autocompleteOptionsMap[field.name]" [value]="option.value">
                                    {{ option.displayName }}
                                </mat-option>
                            </ng-container>
                        </mat-autocomplete>
                        <button type="button" matSuffix mat-icon-button aria-label="Clear" (click)="clearControl(field.name)" *ngIf="filterForm.get([field.name])?.value">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                </ng-container>

                <ng-container *ngSwitchCase="'daterange'">
                    <mat-form-field appearance="outline" class="w-100" *ngIf="isDateRangeField(field)">
                        <mat-label class="text-overflow-ellipsis">{{ field.displayName }}</mat-label>
                        <mat-date-range-input [rangePicker]="picker">
                            <input matStartDate placeholder="DD-MM-YYYY" [formControlName]="field.nameStart">
                            <input matEndDate placeholder="DD-MM-YYYY" [formControlName]="field.nameEnd">
                        </mat-date-range-input>
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                    </mat-form-field>
                </ng-container>

                <ng-container *ngSwitchCase="'dateperiod'">
                    <ng-container *ngIf="isDatePeriodField(field)">

                        <ng-container [formGroup]="datePeriodRadiosForm">
                            <mat-radio-group [formControlName]="field.name + '_periodType'" (change)="onPeriodTypeChange(field)">
                                <ng-container *ngFor="let option of field.options" [ngSwitch]="option">

                                    <mat-radio-button *ngSwitchCase="'custom'" value="custom">
                                        Rango personalizado
                                    </mat-radio-button>

                                    <mat-radio-button *ngSwitchCase="'month'" value="month">
                                        Mensual
                                    </mat-radio-button>

                                    <mat-radio-button *ngSwitchCase="'year'" value="year">
                                        Anual (Evolutivo)
                                    </mat-radio-button>

                                </ng-container>
                            </mat-radio-group>
                        </ng-container>

                        <div *ngIf="datePeriodRadiosForm.get(field.name + '_periodType')?.value === 'custom'" class="mt-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label class="text-overflow-ellipsis">{{ field.displayName }}</mat-label>
                                <mat-date-range-input [rangePicker]="picker">
                                    <input matStartDate placeholder="DD-MM-YYYY" [formControlName]="field.nameStart">
                                    <input matEndDate placeholder="DD-MM-YYYY" [formControlName]="field.nameEnd">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker></mat-date-range-picker>
                            </mat-form-field>
                        </div>

                        <div *ngIf="datePeriodRadiosForm.get(field.name + '_periodType')?.value === 'month'" class="mt-3">
                            <mat-form-field appearance="outline" class="w-100" (click)="monthPicker.open()" floatLabel="always">
                                <mat-label class="text-overflow-ellipsis">{{ field.displayName }}</mat-label>
                                <mat-date-range-input [rangePicker]="monthPicker">
                                    <input matStartDate placeholder="" [formControlName]="field.nameStart" readonly>
                                    <input matEndDate placeholder="Seleccione un mes" [formControlName]="field.nameEnd" readonly>
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="monthPicker"></mat-datepicker-toggle>
                                <mat-date-range-picker
                                    #monthPicker
                                    startView="year"
                                    panelClass="period-only-picker"
                                    (monthSelected)="chosenMonthHandler($event, monthPicker, field)">
                                </mat-date-range-picker>
                            </mat-form-field>
                        </div>

                        <div *ngIf="datePeriodRadiosForm.get(field.name + '_periodType')?.value === 'year'" class="mt-3">
                            <mat-form-field appearance="outline" class="w-100" (click)="yearPicker.open()" floatLabel="always">
                                <mat-label class="text-overflow-ellipsis">{{ field.displayName }}</mat-label>
                                <mat-date-range-input [rangePicker]="yearPicker">
                                    <input matStartDate placeholder="" [formControlName]="field.nameStart" readonly>
                                    <input matEndDate placeholder="Seleccione un año" [formControlName]="field.nameEnd" readonly>
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="yearPicker"></mat-datepicker-toggle>
                                <mat-date-range-picker
                                    #yearPicker
                                    startView="multi-year"
                                    panelClass="period-only-picker"
                                    (yearSelected)="chosenYearHandler($event, yearPicker, field)">
                                </mat-date-range-picker>
                            </mat-form-field>
                        </div>

                    </ng-container>
                </ng-container>

            </ng-container>
        </div>

        <div class="col-12 d-flex justify-content-end">
            <button mat-flat-button type="button" class="custom-button-secondary no-print mr-5" (click)="onClear()">
                <mat-icon aria-hidden="false" aria-label="Icono de limpiar" fontIcon="delete"
                    class="font-size-button-icon mr-3"></mat-icon>
                Limpiar
            </button>

            <button mat-flat-button type="submit" class="custom-button-primary" [disabled]="filterForm.invalid">
                <mat-icon aria-hidden="false" aria-label="Icono de busqueda" fontIcon="search"
                    class="font-size-button-icon mr-3"></mat-icon>
                Buscar
            </button>
        </div>
    </div>

</form>